module.exports = __webpack_public_path__ + "img/雨夹雪.b76dc1fd.png";